'use client'

import { BottomNavContainer } from '@components/app/ApplySuccessPage/PostApplyPrompt/BottomNavContainer'
import FormSubmitButton from '@components/app/TrialApply/FormSubmitButton.client'
import { useFormListener } from '@components/hooks/useFormListener/index.client'
import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'
import { getProgressBarProps, getStageFromPath } from './getProgressBarProps'

export const TRIAL_APPLY_FORM_ID = 'apply-flow-form'

export const TrialApplyFooter = ({
  children,
}: {
  children?: React.ReactNode
}) => {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  const questionCount = parseInt(searchParams?.get('questionCount') ?? '0', 10)
  const pathParts = pathname?.split('/') ?? []
  const stage = getStageFromPath(pathParts)

  const currProgressBarProps = getProgressBarProps(pathParts, questionCount)

  const [progressBarProps, setProgressBarProps] = useState({
    ...currProgressBarProps,
    currentStepIndex: Math.max(
      stage === 'applySuccess'
        ? currProgressBarProps.currentStepIndex - 1
        : currProgressBarProps.currentStepIndex,
      0,
    ), // accounts for differences in progress increment across stages
  })
  const { formStatus } = useFormListener(TRIAL_APPLY_FORM_ID)

  useEffect(() => {
    setProgressBarProps({
      ...currProgressBarProps,
      currentStepIndex:
        stage === 'trialApply'
          ? currProgressBarProps.currentStepIndex + 1
          : currProgressBarProps.currentStepIndex, // accounts for differences in progress increment across stages
    })
  }, [])

  useEffect(() => {
    if (formStatus === 'pending') {
      // increment the progress bar
      setProgressBarProps((prevProps) => ({
        ...prevProps,
        currentStepIndex: prevProps.currentStepIndex + 1,
      }))
    }
  }, [formStatus])

  return (
    <BottomNavContainer progressBarProps={progressBarProps}>
      {children ? (
        children
      ) : (
        <div className='flex w-full flex-col-reverse items-center justify-end gap-4 md:w-2/3 md:flex-row'>
          <FormSubmitButton
            className={
              formStatus === 'invalid'
                ? 'bg-neutral300 hover:bg-neutral300 active:bg-neutral300'
                : ''
            }
            formId={TRIAL_APPLY_FORM_ID}
            loading={formStatus === 'pending'}
          />
        </div>
      )}
    </BottomNavContainer>
  )
}
